<template>
  <div v-if="mcpTools?.length">
    <h3 class="mb-8 text-center font-semibold">
      {{ mcpTools?.length }} Unified MCP tools
    </h3>

    <div v-if="loading">Loading MCP tools...</div>
    <div v-else-if="error"></div>
    <div v-else>

      <div class="flex flex-wrap">
        <div v-for="tool in mcpTools" :key="tool.id" class="sm:pr-2 pb-2 w-full xl:w-1/4 sm:w-1/3">
          <div class="border rounded-md h-full">
            <div class="bg-transparent px-4 py-4 text-md text-light-gray">
              <span class="font-semibold">{{ tool.description }}</span>

              <!-- </div>
                        <div class="px-4 py-4"> -->
              <!-- <div class="flex flex-wrap items-center"> -->
              <!-- <Badge :label="tool.id.substring(0, 30)" class="mr-1 mb-1" /> -->
              <small v-if="tool.parameter_count > 1" class="text-gray-500 ml-2 whitespace-nowrap">
                {{ tool.parameter_count }} parameters
              </small>
              <small v-else-if="tool.parameter_count === 1" class="text-gray-500 ml-2 whitespace-nowrap">
                1 parameter
              </small>
              <!-- <a target="_blank" href="https://docs.unified.to/mcp">
                                <Icon name="ic:round-keyboard-arrow-right" />
                            </a> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Written at build time by `npm run getmcptools` (server/utils/fetch-mcp-tools.ts) from data/mcp_tools.json.
type TMCPTool = {
  id: string;
  description: string;
  parameter_count: number;
};

const props = defineProps<{
  type: string; // integration type
}>();

// Static file, so no credential reaches the browser. Integrations without MCP tools have no file,
// and the section stays hidden.
const { data: mcpTools, error, pending: loading } = await useFetch<TMCPTool[]>(`/mcp-tools/${props.type}.json`, {
  key: `mcp-tools-${props.type}`, // Cache key for deduplication
  server: false, // Fetch once at runtime on the client, not baked in at prerender
});
</script>
